<template>
  <div class="bsd-section">
    <div class="row">
      <div class="col-sm-6">
        <alert-box ref="alertBox" class="spacer-bottom-m" />
      </div>

      <div class="col-md-3 col-sm-6">
        <router-link
          tag="button"
          v-if="isBoleto"
          :to="{ name: 'cp-boleto' }"
          class="z-button z-button--secondary z-button--block"
        >
          Visualizar boleto
        </router-link>

        <router-link
          tag="button"
          v-if="isPix"
          :to="{ name: 'cp-pix' }"
          class="z-button z-button--secondary z-button--block"
        >
          Visualizar pix
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import AlertBox from 'components/zilla/alert-box';

export default {
  props: {
    periodName: {
      type: String,
      required: true,
    },
    paymentMethod: {
      type: String,
      required: true,
    },
  },
  components: {
    AlertBox,
  },
  computed: {
    isBoleto() {
      return this.paymentMethod === 'boleto';
    },
    isPix() {
      return this.paymentMethod === 'pix';
    },
  },
  mounted() {
    this.$refs.alertBox.show(
      'warning',
      `Você possui um ${this.paymentMethod} de quitação do ${this.periodName} em aberto`,
      null,
    );
  },
};
</script>
